<template>
  <div>
    <CRow>
      <CCol sm="12">
        <PaymentsView
          :id="id"
          :is_new="id > 0 ? false : true"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import PaymentsView from '../components/payments/PaymentsView.vue'
 
export default {
  name: 'Payment',
  components: { PaymentsView },
  data: function () {
		return {
      id: 0
    }
  },
  mounted: async function() {
      this.id = await this.$route.params.id;
  },
  methods: {

  }
}
</script>
